import React from "react";

/**
 * Warning that an agent has an active chat when trying to sign out.
 * @returns Warning message.
 */
const ChatWarningSinglar = () => <p>You have an ongoing chat. Signing out will return the customer to the queue.</p>;

export default ChatWarningSinglar;
